<template>
    <Button :class="buttonClass" :data-testid="buttonDataTestid" @click="templateModalVisible = true">
        {{ buttonLabel }}
    </Button>
    <div v-if="templateModalVisible" class="campaign-edit-templates-modal">
        <CampaignAddTemplatesModal v-model="templateModalVisible" />
    </div>
</template>

<script lang="ts">
import CampaignAddTemplatesModal from "@/components/Campaign/CampaignAddTemplatesModal.vue";

export default {
    name: "AddTemplates",
    components: {
        CampaignAddTemplatesModal
    },

    props: {
        buttonLabel: {
            type: String,
            required: true
        },
        buttonDataTestid: {
            type: String,
            required: true
        },
        buttonClass: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            templateModalVisible: false
        };
    }
};
</script>
